import React from "react"

import Components from "./styled"
import { removeJsonExtension } from "src/utils/helpers/json"

interface ChooseJsonProps {
	onSelect: (name: string, json: string) => void
}
const ChooseJson = ({ onSelect }: ChooseJsonProps) => {
	const handleFileChange = (event: any) => {
		const file = event.target.files[0]

		if (file) {
			const reader = new FileReader()

			reader.onload = (e) => {
				try {
					const fileName = removeJsonExtension(file.name) // Get the selected file name
					const fileContent = e?.target?.result
					console.log("CHOOSE JSON", fileName, fileContent)

					if (typeof e?.target?.result === "string")
						onSelect(fileName, e.target.result)
				} catch (error) {
					console.error("Error parsing JSON:", error)
				}
			}

			reader.readAsText(file)
		}
	}

	return (
		<Components.Main>
			<Components.SVG>
				<svg
					width={80}
					height={80}
					viewBox="0 0 80 80"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_8_3)">
						<path
							d="M48.7344 46.3984C47.4609 46.3984 46.5078 46.8281 45.8594 47.6797C45.2109 48.5312 44.8906 49.8047 44.8906 51.4844C44.8906 53.1641 45.2109 54.4375 45.8516 55.2812C46.4922 56.1328 47.4453 56.5547 48.7188 56.5547C51.2656 56.5547 52.5391 54.8594 52.5391 51.4766C52.5313 48.0938 51.2656 46.3984 48.7344 46.3984Z"
							fill="black"
						/>
						<path
							d="M75.5391 37.7031H70V26.25C70 22.8125 68.0078 18.0078 65.5781 15.5781L54.4219 4.42187C51.9922 1.99219 47.1875 0 43.75 0H6.25C2.8125 0 0 2.8125 0 6.25V73.75C0 77.1875 2.8125 80 6.25 80H63.75C67.1875 80 70 77.1875 70 73.75V67.4609H75.5391C77.9922 67.4609 80 65.4531 80 63V42.1641C80 39.7109 77.9922 37.7031 75.5391 37.7031ZM50.0078 7.23437C50.3516 7.47656 50.6484 7.71875 50.8906 7.96094L62.0469 19.1172C62.2891 19.3594 62.5313 19.6562 62.7734 20H50.0078V7.23437ZM65 73.75C65 74.4297 64.4297 75 63.75 75H6.25C5.57031 75 5 74.4297 5 73.75V6.25C5 5.57031 5.57031 5 6.25 5H43.75C44.125 5 44.5469 5.04687 45 5.13281V25H64.8672C64.9531 25.4531 65 25.875 65 26.25V37.7031H17.9844C15.5312 37.7031 13.5234 39.7109 13.5234 42.1641V63.0078C13.5234 65.4609 15.5312 67.4687 17.9844 67.4687H65V73.75ZM55.8828 51.4922C55.8828 53.9844 55.2656 55.8984 54.0312 57.2422C52.7969 58.5859 51.0234 59.25 48.7187 59.25C46.4141 59.25 44.6406 58.5781 43.4062 57.2422C42.1719 55.9063 41.5547 53.9844 41.5547 51.4766C41.5547 48.9688 42.1719 47.0547 43.4141 45.7344C44.6563 44.4141 46.4297 43.75 48.7422 43.75C51.0547 43.75 52.8281 44.4141 54.0547 45.75C55.2656 47.0781 55.8828 48.9922 55.8828 51.4922ZM35.4922 54.2266C35.3281 54 35.0859 53.7734 34.7656 53.5625C34.4453 53.3516 33.7969 53.0078 32.8125 52.5391C31.8906 52.1094 31.2031 51.6875 30.7422 51.2891C30.2812 50.8906 29.9141 50.4297 29.6406 49.8984C29.3672 49.3672 29.2266 48.75 29.2266 48.0469C29.2266 46.7109 29.6797 45.6641 30.5781 44.9062C31.4844 44.1406 32.7266 43.7656 34.3203 43.7656C35.1016 43.7656 35.8516 43.8594 36.5625 44.0469C37.2734 44.2344 38.0156 44.4922 38.7891 44.8281L37.7578 47.3125C36.9531 46.9844 36.2891 46.75 35.7656 46.625C35.2422 46.4922 34.7266 46.4297 34.2188 46.4297C33.6172 46.4297 33.1484 46.5703 32.8281 46.8516C32.5078 47.1328 32.3438 47.5 32.3438 47.9531C32.3438 48.2344 32.4062 48.4766 32.5391 48.6875C32.6719 48.8984 32.875 49.1016 33.1641 49.2969C33.4453 49.4922 34.125 49.8438 35.1875 50.3516C36.5937 51.0234 37.5625 51.6953 38.0781 52.375C38.6016 53.0547 38.8594 53.8828 38.8594 54.8594C38.8594 56.2188 38.3672 57.2891 37.3906 58.0703C36.4141 58.8516 35.0469 59.2422 33.3047 59.2422C31.6953 59.2422 30.2734 58.9375 29.0391 58.3359V55.3672C30.0547 55.8203 30.9141 56.1406 31.6172 56.3281C32.3203 56.5156 32.9609 56.6094 33.5469 56.6094C34.25 56.6094 34.7812 56.4766 35.1562 56.2109C35.5313 55.9453 35.7188 55.5469 35.7188 55.0156C35.7422 54.7188 35.6562 54.4531 35.4922 54.2266ZM25.5781 43.9844V58.0781C25.5781 59.8359 25.1797 61.1719 24.375 62.0937C23.5703 63.0156 22.3828 63.4766 20.8125 63.4766C20.0937 63.4766 19.4609 63.3984 18.9297 63.25V60.5937C19.4766 60.7344 19.9766 60.7969 20.4297 60.7969C21.1328 60.7969 21.6328 60.5781 21.9297 60.1406C22.2344 59.7031 22.3828 59.0234 22.3828 58.0937V43.9844H25.5781ZM72.9688 59.0391H68.9141L62.3672 47.6484H62.2656C62.3984 49.6641 62.4609 51.0938 62.4609 51.9531V59.0391H59.6094V43.9844H63.6328L70.1719 55.2656H70.2422C70.1406 53.3125 70.0859 51.9219 70.0859 51.1172V43.9844H72.9688V59.0391Z"
							fill="black"
						/>
					</g>
					<defs>
						<clipPath id="clip0_8_3">
							<rect width={80} height={80} fill="white" />
						</clipPath>
					</defs>
				</svg>
			</Components.SVG>
			<Components.Title>Import Design File</Components.Title>

			<Components.ChooseButton htmlFor="file">
				Select JSON
				<input
					id="file"
					type="file"
					onChange={handleFileChange}
					accept=".json"
					style={{ display: "none" }}
				/>
			</Components.ChooseButton>
		</Components.Main>
	)
}
export default ChooseJson
